// DOM-attribute that carries the backend image reference (a TemplateImageFile
// id) on an `<img>` node inside the editor. The wire format stored by the
// backend is `<img src="{{image '<id>'}}">`; in the editor we swap the `src`
// for a signed preview URL and keep the id here so the roundtrip converter can
// restore the `{{image '<id>'}}` reference on save. Single constant so the
// extension, converters and picker all agree on the marker.
export const TEMPLATE_IMAGE_ID_ATTR = 'data-template-image-id';
